// extracted by mini-css-extract-plugin
export default {"appButton":"AppButton_appButton__K-JTg","app-font-bold":"AppButton_app-font-bold__aTYUY"};